import React from 'react';

export function Tabs({ value, onChange, children, className = '' }) {
  return (
    <div className={`ds-tabs ${className}`.trim()}>
      <div className="ds-tabs__list" role="tablist">
        {React.Children.map(children, (child, index) => {
          if (!React.isValidElement(child)) return null;
          return React.cloneElement(child, {
            active: value === index,
            onSelect: () => onChange(index),
            tabIndex: index,
          });
        })}
      </div>
    </div>
  );
}

export function Tab({ label, active, onSelect, tabIndex }) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      className={`ds-tabs__tab${active ? ' ds-tabs__tab--active' : ''}`}
      onClick={onSelect}
      id={`ds-tab-${tabIndex}`}
    >
      {label}
    </button>
  );
}

export default Tabs;
